/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

//import Slider from 'react-slick';
//import "slick-carousel/slick/slick.css";
//import "slick-carousel/slick/slick-theme.css";

import ScrollMenu from 'react-horizontal-scrolling-menu';
import ContentItemWide from '../../components/ContentItemWide';

//import { AnimateOnChange } from 'react-animation'

class ViewContent extends Component {
  state = {
    menuIndex: 0,
    slideIndex: 1,
    slidePlay: true,
    mouseOn: false,
    onEvent: false,
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._getUserInfo();
    setTimeout(() => {
      this._getContent('/viewContent');
    }, 500);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _getUserInfo = async () => {
    const { loginId } = this.props;

    if (loginId === '' || loginId === null || loginId === undefined) {
    } else {
      const result = await this._getUserInfoApi();
      if (result) {
        const intReturn = result.data[0].intReturn;
        const userInfo = result.data[0].listData;

        if (intReturn === 0) {
          if (this._isMounted) {
            this.setState({
              userInfo,
            });
          }
        }
      }
    }
  };
  _getUserInfoApi = () => {
    const { apiUrl, loginId, pkg, history } = this.props;
    // const at = localStorage.getItem("at");
    const at = this.getCookie('at');
    //console.log(apiUrl + '/getUserInfo?userid=' + loginId)
    return axios(
      apiUrl + '/getUserInfo_pkg?userid=' + loginId + '&pkg=' + pkg,
      {
        headers: {
          Authorization: 'bearer ' + at,
        },
      }
    )
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(0);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async (part) => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      if (part === 0) {
        this._getUserInfo();
      } else if (part === 1) {
        this._getContent('/viewContent');
      } else if (part === 2) {
        this._getContent('/zzimContent');
      }
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };

  _getContent = async (api) => {
    const { loginId } = this.props;

    if (loginId === '' || loginId === undefined || loginId === null) {
      //console.log('no login...')
    } else {
      const result = await this._getContentApi(api);
      if (result) {
        const intReturn = result.data[0].intReturn;
        const contentList = result.data[0].listData;

        if (intReturn === 0) {
          this.setState({
            contentList,
          });
        }
      }
    }
  };
  _getContentApi = (api) => {
    const { apiUrl, loginId, history } = this.props;
    // const { menuIndex } = this.state;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    return axios(apiUrl + api + '?userid=' + loginId, {
      headers: {
        Authorization: 'bearer ' + at,
      },
    })
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          if (api === '/viewContent') {
            this._refreshToken(1);
          } else {
            this._refreshToken(2);
          }
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _onViewContent = () => {
    //console.log('aaa')
    this.setState({
      menuIndex: 0,
    });
    this._getContent('/viewContent');
  };
  _onZzimContent = () => {
    //console.log('bbb')
    this.setState({
      menuIndex: 1,
    });
    this._getContent('/zzimContent');
  };
  _renderItem = () => {
    const { contentList, menuIndex } = this.state;

    const list = contentList.map((item, index) => {
      return (
        <div key={index}>
          <ContentItemWide
            refer={'view'}
            menuIndex={menuIndex}
            title={item.title}
            subTitle={item.subTitle}
            img={item.img}
            overImg={item.overImg}
            contentSerial={item.contentSerial}
            contentPartSerial={item.contentPartSerial}
            subPartSerial2={item.vodSerial}
            subPartSerial3={item.subPartSerial3}
            lastContentPartSerial={item.lastContentPartSerial}
            pos={item.pos}
            mediaTime={item.mediaTime}
            dRank={item.dRank}
            opening={item.opening}
            wishFlag={item.wishFlag}
            onInit={this._getContent}
            num={index + 1}
            onEndItemSlide={this._onEndItemSlide}
          />
        </div>
      );
    });

    return list;
  };
  _onEndItemSlide = (num, over) => {
    const { slideIndex } = this.state;
    let scrollPos;
    ////console.log(slideIndex)
    if (num === null || num === '' || num === undefined) {
      //console.log()
    } else {
      //console.log(over, num, slideIndex)
      if (over) {
        if (num % 6 === 0) {
          if (slideIndex === 1) {
            scrollPos = 1;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 2) {
            scrollPos = 7;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 3) {
            scrollPos = 13;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 4) {
            scrollPos = 19;
            this.scrollMenu.scrollTo(scrollPos.toString());
          }
        }
      } else {
        if (num % 6 === 0) {
          if (slideIndex === 1) {
            scrollPos = 0;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 2) {
            scrollPos = 6;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 3) {
            scrollPos = 12;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 4) {
            scrollPos = 18;
            this.scrollMenu.scrollTo(scrollPos.toString());
          }
        }
      }
    }
  };
  _onToggleMouseOn = () => {
    //const { mouseOn } = this.state;

    this.setState({
      mouseOn: true,
    });
  };
  _onToggleMouseOff = () => {
    //const { mouseOn } = this.state;

    this.setState({
      mouseOn: false,
    });
  };
  _onSelect = (key) => {
    //console.log(key)
  };
  _arrowNext = () => {
    const { slideIndex, contentList } = this.state;
    const cnt = contentList.length;
    const page = Math.round(cnt / 6);

    if (slideIndex < page) {
      this.setState({
        slideIndex: slideIndex + 1,
      });
    }
  };
  _arrowPrev = () => {
    const { slideIndex } = this.state;
    // const cnt = contentList.length;
    // const page = Math.round(cnt / 6);

    //if(slideIndex < 1) {
    this.setState({
      slideIndex: slideIndex - 1,
    });
    //}
  };
  _renderDot = () => {
    const { slideIndex, contentList } = this.state;
    const cnt = contentList.length;
    let page = Math.round(cnt / 6);
    if (page === 0) {
      page = 1;
    }
    let arr = [];

    for (let i = 1; i <= page; i++) {
      arr.push(<em key={i} className={i === slideIndex ? 'on' : null}></em>);
    }
    const list = arr.map((item) => {
      return item;
    });
    ////console.log()
    return list;
  };
  _onMore = () => {
    const { menuIndex } = this.state;
    const { history } = this.props;
    if (menuIndex === 0) {
      history.push('/mypage/1');
    } else {
      history.push('/mypage/0');
    }
  };
  render() {
    const { contentList, mouseOn, slideIndex, menuIndex, userInfo } =
      this.state;
    return (
      <Fragment>
        {contentList ? (
          <div className="main_list_style ">
            {' '}
            {/*padding_top*/}
            <h1 style={{ marginBottom: -40 }}>
              <strong>{userInfo ? userInfo[0].nicName : null}님</strong>
              <span
                className={menuIndex === 0 ? 'on' : null}
                onClick={this._onViewContent}
              >
                감상중인작품
              </span>
              <span
                className={menuIndex === 1 ? 'on' : null}
                onClick={this._onZzimContent}
              >
                찜한 작품
              </span>
              <div>
                {this._renderDot()}
                <a style={{ cursor: 'pointer' }} onClick={this._onMore}>
                  더보기
                </a>
              </div>
            </h1>
            <div
              className="main_list_goup1"
              style={{ with: '100%' }}
              onMouseEnter={this._onToggleMouseOn}
              onMouseLeave={this._onToggleMouseOff}
            >
              {/*리스트 오브 시 좌우 버튼 생김*/}
              <div className="div_ul">
                <ScrollMenu
                  data={contentList ? this._renderItem() : null}
                  arrowLeft={
                    mouseOn ? (
                      slideIndex === 1 ? null : (
                        <a
                          className="left_btn"
                          style={{ cursor: 'pointer' }}
                          onClick={this._arrowPrev}
                        >
                          <span className={'on'}>이전</span>
                        </a>
                      )
                    ) : null
                  }
                  arrowRight={
                    mouseOn ? (
                      slideIndex > parseInt(contentList.length / 6) ? null : (
                        <a
                          className="right_btn"
                          style={{ cursor: 'pointer' }}
                          onClick={this._arrowNext}
                        >
                          <span className={'on'}>다음</span>
                        </a>
                      )
                    ) : null
                  }
                  wheel={false}
                  dragging={true}
                  transition={0.5}
                  translate={2}
                  alignOnResize={true}
                  //inertiaScrolling={true}
                  //inertiaScrollingSlowdown={3}
                  //wrapperStyle={{border: 0, backgroundColor: '#000'}}
                  //wrapperClass={'div_ul'}
                  alignCenter={false}
                  hideSingleArrow={true}
                  hideArrows={mouseOn}
                  onUpdate={(t) => {
                    if (t) {
                      //console.log(t)
                    }
                  }}
                  ref={(ref) => (this.scrollMenu = ref)}
                  scrollBy={6}
                  //innerWrapperStyle={{textAlign: 'center'}}
                  //onSelect={this._onSelect}
                  //selected={selected}
                />
              </div>

              <div className="clear"></div>
            </div>
          </div>
        ) : null}

        {/*
                <div><span onClick={this._onViewContent}>감상중인 작품</span><span onClick={this._onZzimContent}>찜한 작품</span></div>
                <div>
                    { contentList ? this._renderItem() : null }
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(ViewContent));
